<template>
  <VDialog v-model="dialog" max-width="450">
    <VCard style="overflow: auto">
      <VBtn absolute style="right: 0" class="mt-1" icon @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle style="word-break: break-word">{{
        isChangeInitiator ? $t("changeInitiator") : $t("addAnotherRecipient")
      }}</VCardTitle>

      <VCardText>
        <ValidationObserver ref="validationObserver" v-slot="{ handleSubmit }">
          <VueSelect
            clearable
            infinite
            @item-resolved="setDepartments"
            @next-page-resolved="
              (data) => setDepartments([...departments, ...data])
            "
            :get-item-promise="
              ({ text, page }) =>
                $store.dispatch('getDepartments', {
                  page,
                  name: text,
                  limit: 15,
                })
            "
            :items="departments"
            @input="clearUserSelected"
            v-model="departmentId"
            :label="$t('selectSection')"
            class="product-select-in-modal"
          ></VueSelect>
          <VueSelect
            clearable
            infinite
            ref="userListRef"
            rules="required"
            @item-resolved="setUsers"
            @next-page-resolved="(data) => setUsers([...users, ...data])"
            :get-item-promise="
              ({ text, page }) =>
                $store.dispatch('getUserList', {
                  departmentId,
                  page,
                  firstName: text,
                  limit: 15,
                })
            "
            :items="users"
            v-model="userId"
            item-text="firstName"
            :label="$t('chooseInitiator')"
            class="product-select-in-modal"
          ></VueSelect>

          <VBtn
            class="mt-4"
            width="100%"
            color="primary"
            @click="
              handleSubmit(() => $refs.changeInitiatorConfirmDialogRef.open())
            "
            >{{ $t("save") }}</VBtn
          >
        </ValidationObserver>
      </VCardText>
    </VCard>
    <WarningDialog
      @apply="changeInitiatorConfirm"
      :description="isChangeInitiator ? 'wantToChange' : 'wantToAdd'"
      yesText="yes"
      v-model="isChangeInitiatorConfirm"
      ref="changeInitiatorConfirmDialogRef"
    />
  </VDialog>
</template>

<script>
import VueSelect from "@/components/ui/vue-select/VueSelect";
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";

export default {
  name: "ChangeInitiatorDialog",
  data() {
    return {
      isChangeInitiatorConfirm: false,
      isChangeInitiator: true,
      dialog: false,
      departments: [],
      users: [],
      departmentId: null,
      userId: null,
      initiatorId: null,
    };
  },
  components: {
    VueSelect,
    WarningDialog,
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.clearUserSelected();
        this.$refs.validationObserver.reset();
        this.departmentId = null;
      }
    },
  },
  methods: {
    changeInitiatorConfirm() {
      if (this.isChangeInitiator) {
        this.changeInitiator();
      } else {
        this.addAnotherInitiator();
      }
      this.close();
    },
    async changeInitiator() {
      this.showLoading();
      try {
        await this.$http.post("/user-agreement/change-initiator", {
          userAgreementId: this.initiatorId,
          userId: this.userId,
        });
        this.$emit("updateInitiatorList");
        this.setSuccess({ text: this.$t("successfullySent") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async addAnotherInitiator() {
      this.showLoading();
      try {
        await this.$http.post("/user-agreement/create", {
          contractItemId: this.initiatorId,
          ozl: false,
          userId: this.userId,
        });
        this.$emit("updateInitiatorList");
        this.setSuccess({ text: this.$t("successfullySent") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    clearUserSelected() {
      this.$refs.userListRef.reset();
      this.$refs.userListRef.clear();
      this.users = [];
    },
    setDepartments(departments) {
      this.departments = departments;
    },
    setUsers(users) {
      this.users = users;
    },
    open(initiatorId, isChangeInitiator = true) {
      this.initiatorId = initiatorId;
      this.isChangeInitiator = isChangeInitiator;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
